export const getUserHasZorseChatScope = userInfo => {
  var _userInfo$user;
  return userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.scopes) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.includes('zorse-chat');
};
export const getUserHasZorseWebticketScope = userInfo => {
  var _userInfo$user2;
  return userInfo === null || userInfo === void 0 || (_userInfo$user2 = userInfo.user) === null || _userInfo$user2 === void 0 || (_userInfo$user2 = _userInfo$user2.scopes) === null || _userInfo$user2 === void 0 ? void 0 : _userInfo$user2.includes('zorse-webticket');
};